<div class="selectCountry-item">
    <span class="selectCountry-country">{{ languageName }}</span>
    <span class="selectCountry-language">{{ translateToEn }}</span>
</div>
